import { QuestionOptionName as Question } from "@/components/features/items/edit/option/_shared/ui/components/name/name";

import { useOptionI18nName } from "./hooks";

export const QuestionOptionI18nName = () => {
	const { name, onSetName } = useOptionI18nName();

	const guide = "他のオプションとの違いがわかりやすい名前にしましょう。150文字まで入力ができます。";

	return <Question guide={guide} name={name} onSetName={onSetName} />;
};

QuestionOptionI18nName.displayName = "QuestionOptionI18nName";
